/** @format */

import FilterActive from 'frontier/components/search/filter_active_list';
import {SearchContext} from 'frontier/components/search/index';
import Filter from 'frontier/components/search/filter';
import React, {forwardRef, useContext} from 'react';
import {IfElse, If} from 'frontier-utilities';

// styles
import './search.scss';

function Search(props, ref) {
    const [search, setSearch] = React.useState(decodeURIComponent(props.search ?? ''));

    const handleSearch = ({target: {value}}) => {
        setSearch(value);
        props.onSearch({search: {$set: encodeURIComponent(value)}, page: {$set: 1}});
    };

    const handleAddFilter = newFilter => {
        props.onAddFilter(newFilter);
    };

    const handleResetInput = () => {
        setSearch('');
        props.onReset();
    };

    return (
        <div className="search-46th">
            <div className="search-46th__container d-flex align-items-center justify-content-start">
                <If condition={props.filter_option_list && props.filter_option_list.length > 0}>
                    <div className="container-46th__filters">
                        <Filter
                            filter_option_list={props.filter_option_list}
                            onAdd={handleAddFilter}
                            className="filter-77yy"
                            filters={props.filters}
                            activeLabel="Close"
                            label="Filter"
                        />
                    </div>
                </If>
                <div className="search-46th__input-box d-flex align-items-center justify-content-start w-100">
                    <IfElse condition={props.search != '' || props.filters.length > 0}>
                        <button
                            className="p-0 m-0 d-flex align-items-center justify-content-center"
                            onClick={handleResetInput}
                            type="button">
                            <i className="fa fa-close" style={{lineHeight: '1.5'}} />
                        </button>
                        <span className="d-flex align-items-center justify-content-center">
                            <i className="fa-solid fa-search" />
                        </span>
                    </IfElse>
                    <input
                        className="input-box-46th__input"
                        placeholder={props.placeholder}
                        onChange={handleSearch}
                        autoComplete="off"
                        value={search}
                        type="text"
                    />
                </div>
                <div className="input-box-46th__filter-status">
                    <IfElse condition={props.pending}>
                        <div className="filter-status-46th__pending d-flex align-items-center justify-content-start">
                            <i className="fa fa-spinner fa-spin" />
                        </div>
                        <div className="filter-status-46th__done d-flex align-items-center justify-content-start">
                            <i className="fa fa-check-circle" />
                        </div>
                    </IfElse>
                </div>
            </div>
            <FilterActive filters={props.filters} onRemove={props.onRemoveFilter} />
        </div>
    );
}

function SearchWithContext({filter_option_list = [], placeholder = ''}) {
    const ctx = useContext(SearchContext);

    return (
        <Search
            search={ctx.search}
            filters={ctx.filters}
            onSearch={ctx.onSearch}
            onReset={ctx.onReset}
            onAddFilter={ctx.onAddFilter}
            onRemoveFilter={ctx.onRemoveFilter}
            filter_option_list={filter_option_list}
            pending={ctx.pending}
            placeholder={placeholder}
        />
    );
}

export default Search;
export {SearchWithContext};
